export default "__VITE_ASSET__DPXeir8B__"